export default {
  buttonTitle: {
    en: 'Send SMS',
  },
  text: {
    en: `
      {userFirstName} has given you a FREE fragrance with Scentbird.
      To claim your {gender, select, female {perfume} male {cologne}}, sign up using this link: {link}
    `,
  },
}
